export default __webpack_public_path__ + "media/images/icons/video-play-f2127deda35d057e7cce847d87fef830.png";